import React from 'react';
import { NextSeo } from 'next-seo';
import { useTranslation } from 'src/app/i18n';
import config from 'src/config';
import InvisibleTitle from 'src/components/seo/InvisibleTitle';

const baseUrl = process.env.SITE_URL || config.baseCononicalUrl;

const ATeamSeo = () => {
    const { t } = useTranslation('common');
    return (
        <>
        <NextSeo
            title={t('title.ateam')}
            description={t('description.ateam')}
            canonical={`${baseUrl}/a-team`}
        />
        <InvisibleTitle title={t('title.ateam')} />
        </>
    );
};

export default ATeamSeo;
